import Skeleton from '../Skeleton';
import Destacat from '../Destacat';
import __isEmpty from 'lodash/isEmpty';
import clsx from 'clsx';
import styles from './mosaic.module.scss';

const SkeletonMosaic = (props) => {
    const { titol, numColumns, hGap, vGap, format, tipologia, skeletonItems, className, isLoading, showButtonMoreItems } = props;

    const stylesContainerMosaic = clsx({
        [styles.contenidorMosaic]: true
    });
    const stylesMosaic = clsx({
        [styles.mosaic]: true,
        [className]: !!className,
        [styles[`gap-${hGap}`]]: true,
        [styles[`columns-${numColumns}`]]: !className && !!numColumns
    });

    const itemsToRender = () => {
        return Array.from({ length: skeletonItems }, (_, numElement) => (
            <Destacat key={`mosaic-${format}-${numElement}`} format={format} tipologia={tipologia} isLoading={isLoading} />
        ));
    };

    return (
        <div className={stylesContainerMosaic}>
            {!__isEmpty(titol) && <Skeleton titol />}
            <div style={{ gap: `${vGap}px ${hGap}px` }} className={`${stylesMosaic} mosaic`}>
                {itemsToRender()}
            </div>
            {showButtonMoreItems && <Skeleton boto />}
        </div>
    );
};

SkeletonMosaic.defaultProps = {
    skeletonItems: 3
};

export default SkeletonMosaic;
